import React from "react";
import { MdWarning } from "react-icons/md";
import Modal from "react-modal";
import "./DeleteConfirmModal.css";

const DeleteConfirmModal = ({ isOpen, onClose, categoryName, onConfirm, deleting }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        if (!deleting) onClose();
      }}
      style={{
        overlay: { zIndex: 1100, background: "rgba(0,0,0,0.6)" },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxWidth: 420,
          margin: 0,
          padding: 0,
          border: "none",
          borderRadius: 12,
          overflow: "hidden",
          background: "transparent",
        },
      }}
    >
      <div className="delete-modal__body">
        <div className="delete-modal__inner">
          <div className="delete-modal__icon-wrapper">
            <MdWarning size={24} className="delete-modal__icon" />
          </div>
          <h6 className="delete-modal__title">Delete Ticket Category</h6>
          <p className="delete-modal__text">
            Are you sure you want to delete the category{" "}
            <strong>{categoryName}</strong> and all its reasons?
          </p>
          <p className="delete-modal__subtext">This action cannot be undone.</p>
          <div className="delete-modal__actions">
            <button
              className="btn btn-outline-secondary btn-sm delete-modal__btn"
              onClick={onClose}
              disabled={deleting}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger btn-sm delete-modal__btn"
              onClick={onConfirm}
              disabled={deleting}
            >
              {deleting ? "Deleting..." : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
